var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSmalllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1136_15931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5391 26.2231H22.5967V24.2808C22.5967 22.6716 21.2923 21.3672 19.6831 21.3672H13.856C12.2468 21.3672 10.9424 22.6716 10.9424 24.2808V26.2231H9V24.2808C9 21.5989 11.1741 19.4248 13.856 19.4248H19.6831C22.365 19.4248 24.5391 21.5989 24.5391 24.2808V26.2231ZM16.7695 17.4824C13.5513 17.4824 10.9424 14.8735 10.9424 11.6553C10.9424 8.43703 13.5513 5.82812 16.7695 5.82812C19.9878 5.82812 22.5967 8.43703 22.5967 11.6553C22.5967 14.8735 19.9878 17.4824 16.7695 17.4824ZM16.7695 15.4656C18.915 15.4656 20.4229 13.8008 20.4229 11.6553C20.4229 9.50978 18.915 7.96184 16.7695 7.96184C14.624 7.96184 13.0815 9.50978 13.0815 11.6553C13.0815 13.8008 14.624 15.4656 16.7695 15.4656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_15931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(8.76562 5.02539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSmalllogo);
export default __webpack_public_path__ + "static/media/profileSmalllogo.10809bff953167053365f41c7932d8c8.svg";
export { ForwardRef as ReactComponent };